




























import { Vue, Component } from 'vue-property-decorator';

import buttonGreen from '@/components/atomic/atoms/ButtonGreen.vue';
import buttonBlack from '@/components/atomic/atoms/ButtonBlack.vue';


@Component({
  name: 'AboutSection',
  components: {
    buttonGreen,
    buttonBlack,
  },
})
/**
 * @vuese
 * @group Page/AboutSection
 * AboutSection component
 */
export default class AboutSection extends Vue {
  // [method]
  install() {}

  corporateServices() {}
}
